import CytoscapeComponent from 'react-cytoscapejs';
import cytoscape from 'cytoscape';
import cyCanvas from 'cytoscape-canvas'
import d3Force from "cytoscape-d3-force";
import dagre from "cytoscape-dagre";
import fcose from "cytoscape-fcose";
import klay from "cytoscape-klay"; 

import { doGetRequest } from "../api/ApiUtils";
import { breadthfirstLayout, circleLayout, concentricLayout, coseLayout } from '../config/graphlayouts';
import { HelpPanel } from '@cloudscape-design/components';

cytoscape.use(klay);
cytoscape.use(dagre);
cytoscape.use(d3Force);
cytoscape.use(fcose);
cyCanvas(cytoscape);

export default (props) => {
    const hasSelection = (props.data.length > 0);
    const isLoading = props.isLoading;
    const graphViewStyle = props.viewStyle || "concentric";
    const allowDblClick = props.allowExploration;
    const emptyMessage = props.emptyMessage || "Please choose a disease from the drop-down to view its associated ontology."

    let myCyRef;

    const getGraphLayout = () => {
        if (graphViewStyle === "concentric")
            return concentricLayout;
        else if (graphViewStyle === "hierarchical")
            return breadthfirstLayout;
        else if (graphViewStyle === "cose")
            return coseLayout;
        else if (graphViewStyle === "circle")
            return circleLayout;
        else
            return null;
    }

    const updateGraphFromNode = (nodeId) => {
        doGetRequest('get-neighbours',`id=${nodeId}&limit=20`,false,(data) => {
            for (var i=0; i<data.elements.length; i++){
                myCyRef.add([
                    data.elements[i]
                ]);
            }
            myCyRef.layout(getGraphLayout()).run();
            myCyRef.style()
                .selector('node[node_type="disease"]')
                    .style('background-color','#FFF2CC')
                    //.style('border','3px solid #E2CA82')
                .selector('node[node_type="icd10"]')
                    .style('background-color','#E1D5E7')
                    //.style('border','3px solid #C8B5D2')
                .selector('node[node_type="journal"]')
                    .style('background-color','#DAE8FC')
                    //.style('border','3px solid #6C8EBF')
                .selector('node[node_type="snomedct"]')
                    .style('background-color','#D5E8D4')
                    //.style('border','3px solid #91BD79')  
                .update();
            myCyRef.fit();
        });
    }

    if (!hasSelection) {
        if (isLoading) {
            return (<div className="no-disease-selection">Please wait whilst the graph loads.</div>)
        }
        else {
            return (<div className="no-disease-selection">{emptyMessage}</div>)
        }
    } else {
        if (isLoading) {
            return (<div className="no-disease-selection">Please wait whilst the graph loads.</div>)
        }
        else {
            return (
                <>
                    <HelpPanel header={<span>Graph Legend:</span>} className='graph-legend-container'>
                        <div>
                            <ul className='graph-legend'>
                                <li><span className='disease'></span> diseases</li>
                                <li><span className='icd10'></span> icd10</li>
                                <li><span className='snomedct'></span> snomedct</li>
                                <li><span className='journal'></span> journal</li>
                            </ul>
                        </div>
                    </HelpPanel>
                    <CytoscapeComponent
                        style={ { width: '100%', height: '600px' } }
                        cy={cy => {
                            myCyRef = cy;

                            cy.on("dblclick","node",evt => {
                                if (allowDblClick) {
                                    var node = evt.target;
                                    if (node.data().node_type !== 'journal') {
                                        //here we can expand the graph
                                        updateGraphFromNode(node.data().id);
                                    }

                                    console.log(node.data());
                                }
                            });
                            myCyRef.style()
                                .selector('node[node_type="disease"]')
                                    .style('background-color','#FFF2CC')
                                    .style('height','50px')
                                    .style('width','50px')
                                    //.style('border','3px solid #E2CA82')
                                .selector('node[node_type="icd10"]')
                                    .style('background-color','#E1D5E7')
                                    //.style('border','3px solid #C8B5D2')
                                .selector('node[node_type="journal"]')
                                    .style('background-color','#DAE8FC')
                                    .style('height','70px')
                                    .style('width','70px')
                                    //.style('border','3px solid #6C8EBF')
                                .selector('node[node_type="snomedct"]')
                                    .style('background-color','#D5E8D4')
                                    //.style('border','3px solid #91BD79')   
                                .update();
                        }}
                        styleEnabled={true}
                        elements={
                            props.data
                        }
                        layout={getGraphLayout()}
                    />
                </>
            )
        }
    }
}